import { render, staticRenderFns } from "./PointChart.vue?vue&type=template&id=5e77fbcc&scoped=true&"
import script from "./PointChart.vue?vue&type=script&lang=js&"
export * from "./PointChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77fbcc",
  null
  
)

export default component.exports